import { message } from "antd";
import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";

const getReport = async (date, regions, typeId, tagIds) => {
	const day = date.format("YYYY.MM");

	let regionsParams = "";
	let tagsParams = "";

	if (regions && regions.length > 0) {
		regionsParams = regions
			.map((regionId) => `regionIds=${regionId}`)
			.join("&");
	}
	if (tagIds && tagIds.filter(Boolean).length > 0) {
		tagsParams = tagIds.map((tagId) => `tagIds=${tagId}`).join("&");
	}
	const url = `/Meter/meter_report?${regionsParams}${tagsParams}`;
	try {
		const response = await client.get(url, {
			headers: authHeader(),
			params: { date: day, typeId },
		});
		if (response.status === 204) {
			message.warning("Данных для выгрузки по выбранному типу нет");
		}
		if (response.data) {
			const data = Buffer.from(response.data.data, "base64");
			const url = window.URL.createObjectURL(new Blob([data]));
			return [url, response.data.fileName];
		}
	} catch (e) {
		console.log(e);
		message.error("Произошла ошибка, возможно, показаний за этот месяц нет");
	}
};

export default getReport;
